import { useEffect } from 'react';
import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams
} from 'react-router-dom';
import { WEBVIEW_COOKIE } from '../data/Constants';
import { useAuthContext } from '../hooks/AuthContext';
import { setCookie } from '../services/cookieController';
import { isWebview, pushGTMDataLayer } from '../utils/GenericFunctions';
import {
  getTokenSession,
  setRefreshTokenSession,
  setTokenSession
} from '../utils/auth';
import { sessionUserInfo } from '../services/queryController';
import NavBar from '../components/NavBar/NavBar';
import Sidebar from '../components/Sidebar/Sidebar';

const KEY_SESSION_ORIGIN = process.env.REACT_APP_KEY_SESSION_ORIGIN as string;

const TOKEN_URL_PARAM = 'token';
const JWT_URL_PARAM = 'jwt';
const REFRESH_TOKEN_URL_PARAM = 'refresh_token';
const ORIGIN_URL_PARAM = 'origin';

let previousPath: string | null = null;

const ProtectedRoute = () => {
  const { checkAuth, setUser } = useAuthContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  async function validateUserData() {
    try {
      const data = await sessionUserInfo();
      if (data) setUser(data);
    } catch (e) {
      setUser(null);
      console.error(e);
    }
  }

  useEffect(() => {
    const origin =
      searchParams.get(ORIGIN_URL_PARAM) || process.env.ORIGIN_DOMAIN_SBT_SITE;
    const token =
      searchParams.get(TOKEN_URL_PARAM) || searchParams.get(JWT_URL_PARAM);
    const refreshToken = searchParams.get(REFRESH_TOKEN_URL_PARAM);

    if (origin && token && refreshToken) {
      setTokenSession(token);
      setRefreshTokenSession(refreshToken);
      setCookie(KEY_SESSION_ORIGIN, origin);

      const webview = searchParams.get(WEBVIEW_COOKIE);
      if (webview === 'true') setCookie(WEBVIEW_COOKIE, 'true');

      searchParams.delete(TOKEN_URL_PARAM);
      searchParams.delete(REFRESH_TOKEN_URL_PARAM);
      searchParams.delete(ORIGIN_URL_PARAM);
      searchParams.delete(WEBVIEW_COOKIE);
      setSearchParams(searchParams);

      validateUserData();
    }
  }, []);

  function checkIfShowNavbar() {
    if (isWebview()) {
      document.body.classList.add('webview');
    }
  }

  useEffect(() => {
    if (getTokenSession()) validateUserData();
    checkIfShowNavbar();
  }, []);

  useEffect(() => {
    if (checkAuth(searchParams.get(TOKEN_URL_PARAM) || undefined)?.id) {
      if (previousPath !== location.pathname) pushGTMDataLayer();
      previousPath = location.pathname;
    }
  }, [location]);

  return checkAuth(searchParams.get(TOKEN_URL_PARAM) || undefined)?.id ? (
    <div
      style={{
        display: 'flex',
        padding: 4,
        gap: 4,
        minHeight: '-webkit-fill-available'
      }}
    >
      {/* TODO esconder icones para sair do menu na webview */}
      <Sidebar />
      <div className="left-container">
        <NavBar />
        <Outlet />
      </div>
    </div>
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
